module.exports = __webpack_public_path__ + "static/media/DuplicateSlab-Thin.68a1ff1a.eot";